module.exports = __webpack_public_path__ + "img/retail13.47400e82.png";